import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';

@Injectable({
  providedIn: 'root'
})
export class RoutingServerGroupApiService {

  constructor(private http: HttpClient) {}

  private readonly serverGroupUrl: string = 'server/group';

  public getRoutingServerGroups(parameters = {}): Observable<any> {
    const generatedUrl = UrlQueryService.addQueryParameters(this.serverGroupUrl, parameters);

    return this.http.get(generatedUrl);
  }

  public deleteRoutingServerGroup(serverGroupId): Observable<any> {
    return this.http.delete(`${this.serverGroupUrl}/${serverGroupId}`);
  }

  public addRoutingServerGroup(serverGroup): Observable<any> {
    return this.http.post(this.serverGroupUrl, serverGroup);
  }

  public editRoutingServerGroup( serverGroupId, serverGroup): Observable<any> {
    return this.http.put(`${this.serverGroupUrl}/${serverGroupId}`, serverGroup);
  }
}
